import { RestApiProxy, SagasProxy } from 'com-gyf-webcore-servicehub';

/**
 * Manager del guardado de Distribución de Límites
 */
let DistribucionLimitesManager = function () {

    /**
     * 
     * @param {any} data
     * @param {any} sagasCallback
     * @param {any} viewCallback
     */
    function _guardarLimites(data, sagasCallback, viewCallback, executionContext, novedadesCampoLimites) {
        let localValues = _generarNovedades(data, executionContext, novedadesCampoLimites);
        ejecutarSagas(localValues, 'DISTRIBUCION_LIMITES', sagasCallback, viewCallback);
    }

    /**
     * Recorre las entidades filtrando por las que tengan límites editados y los asigna.
     * @param {any} data
     */
    function _generarNovedades(data, executionContext, novedadesCampoLimites) {
        let listEmp = [];
        let listCue = [];
        let listTar = [];

        //Recorre las empresas y si fueron editadas las prepara para ser almacenadas en la BD.
        for (var i = 0; i < data.empresas.length; i++) {
            if (data.empresas[i].hasOwnProperty('Editado') && data.empresas[i].Editado && data.empresas[i].Id > 0) {
                let novedadAgregada;
                let esNovedad = false;
                for (var j = 0; j < data.novedadesEmpresas.length; j++) {
                    if (data.empresas[i].Id == data.novedadesEmpresas[j].EmpresaId) {
                        novedadAgregada = agregarNovedad(0, data.novedadesEmpresas[j], null, data.empresas[i], executionContext, novedadesCampoLimites);
                        listEmp.push(novedadAgregada);
                        esNovedad = true;
                    }
                }

                if (!esNovedad) {
                    data.empresas[i].NovedadTipoId = 3;
                    novedadAgregada = agregarNovedad(0, data.empresas[i], data.empresasNoModificadas[i], null, executionContext, novedadesCampoLimites);
                    listEmp.push(novedadAgregada);
                }
            }
        }

        //Recorre las cuentas y si fueron editadas las prepara para ser almacenadas en la BD.
        for (var i = 0; i < data.cuentas.length; i++) {
            if (data.cuentas[i].hasOwnProperty('Editado') && data.cuentas[i].Editado && data.cuentas[i].Id > 0) {
                let novedadAgregada;
                let esNovedad = false;
                for (var j = 0; j < data.novedadesCuentas.length; j++) {
                    if (data.cuentas[i].Id == data.novedadesCuentas[j].CuentaTarjetaId) {
                        novedadAgregada = agregarNovedad(1, data.novedadesCuentas[j], null, data.cuentas[i], executionContext, novedadesCampoLimites);
                        listCue.push(novedadAgregada);
                        esNovedad = true;
                    }
                }

                if (!esNovedad) {
                    data.cuentas[i].NovedadTipoId = 1;
                    novedadAgregada = agregarNovedad(1, data.cuentas[i], data.cuentasNoModificadas[i], null, executionContext, novedadesCampoLimites);
                    listCue.push(novedadAgregada);
                }
            }
        }

        //Recorre las tarjetas y si fueron editadas las prepara para ser almacenadas en la BD.
        for (var i = 0; i < data.tarjetas.length; i++) {
            if (data.tarjetas[i].hasOwnProperty('Editado') && data.tarjetas[i].Editado && data.tarjetas[i].Id > 0) {
                let novedadAgregada;
                let esNovedad = false;
                for (var j = 0; j < data.novedadesTarjetas.length; j++) {
                    if (data.tarjetas[i].Id == data.novedadesTarjetas[j].TarjetaCreditoId) {
                        novedadAgregada = agregarNovedad(2, data.novedadesTarjetas[j], null, data.tarjetas[i], executionContext, novedadesCampoLimites);
                        listTar.push(novedadAgregada);
                        esNovedad = true;
                    }
                }

                if (!esNovedad) {
                    data.tarjetas[i].NovedadTipoId = 2;
                    let tc = data.tarjetaOriginal ? data.tarjetaOriginal[i] : data.tarjetasNoModificadas[i];
                    novedadAgregada = agregarNovedad(2, data.tarjetas[i], tc, null, executionContext, novedadesCampoLimites);
                    listTar.push(novedadAgregada);
                }
            }
        }

        let parameter = {
            'EMPRESAS': listEmp,
            'CUENTAS': listCue,
            'TARJETAS': listTar
        }

        return parameter
    }

    /**
     * Arma los objetos de novedades
     * @param {any} tipoNovedad
     * @param {any} novedad
     * @param {any} original
     * @param {any} tieneNovedadOriginal
     */
    function agregarNovedad(tipoNovedad, novedad, original, tieneNovedadOriginal, executionContext, novedadesCampoLimites) {

        let novedades = [];
        let novedadNueva = {
            'Id': null,
            'NovedadTipoId': novedad.NovedadTipoId,
            'NovedadCampoId': null,
            'NovedadCampoCodigo': null,
            'NovedadEstadoId': 2,
            'ValorAnterior': null,
            'ValorNovedad': null,
            'FechaHoraModificacion': new Date(),
            'TerminalModificacion': executionContext.terminalId,
            'UsuarioLoginModificacion': executionContext.login,

            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //TODO: Momentaneamente como no esta desarrollado la Confirmacion de Distribucion de Limites, se solicito que se guarden estos datos
            'FechaHoraConfirmacion': new Date(),
            'TerminalConfirmacion': executionContext.terminalId,
            'UsuarioLoginConfirmacion': executionContext.login
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        }

        let novedadFinal = {};

        switch (tipoNovedad) {
            case 0: //Empresa
                let novedadCampoEmpresa = novedadesCampoLimites.find(x => x.Codigo == "LIMCO_EMPR");

                novedadFinal = {
                    'EmpresaVisa': {
                        'Id': null,
                        'Novedades': null
                    }
                }

                if (original != null) {
                    novedadFinal.EmpresaVisa.Id = novedad.Id;
                }
                else {
                    novedadFinal.EmpresaVisa.Id = tieneNovedadOriginal != null ? novedad.EmpresaId : null;
                    novedadNueva.Id = novedad.Id;
                }

                novedadNueva.NovedadCampoId = novedadCampoEmpresa.Id;
                novedadNueva.NovedadCampoCodigo = novedadCampoEmpresa.Codigo;
                novedadNueva.ValorAnterior = original != null ? original.LimiteCompra : tieneNovedadOriginal.LimiteCompra;
                novedadNueva.ValorNovedad = original != null ? novedad.LimiteCompra : novedad.ValorNovedad;

                novedades.push(novedadNueva);
                novedadFinal.EmpresaVisa.Novedades = novedades;
                break;
            case 1: //Cuenta
                let novedadCampoCuenta = novedadesCampoLimites.find(x => x.Codigo == "LIMCO_CUEN");

                novedadFinal = {
                    'CuentaTarjeta': {
                        'Id': null,
                        'Novedades': null
                    }
                }

                if (original != null) {
                    novedadFinal.CuentaTarjeta.Id = novedad.Id;
                }
                else {
                    novedadFinal.CuentaTarjeta.Id = tieneNovedadOriginal != null ? novedad.CuentaTarjetaId : null;
                    novedadNueva.Id = novedad.Id;
                }

                novedadNueva.NovedadCampoId = novedadCampoCuenta.Id;
                novedadNueva.NovedadCampoCodigo = novedadCampoCuenta.Codigo;
                novedadNueva.ValorAnterior = original != null ? original.LimiteCompraId : tieneNovedadOriginal.LimiteCompraId;
                novedadNueva.ValorNovedad = original != null ? novedad.LimiteCompraId : novedad.ValorNovedad;

                novedades.push(novedadNueva);
                novedadFinal.CuentaTarjeta.Novedades = novedades;
                break;
            case 2: //Tarjeta
                let novedadCampoTarjeta = novedadesCampoLimites.find(x => x.Codigo == "LIMCO_TARJ");

                novedadFinal = {
                    'TarjetaCredito': {
                        'Id': null,
                        'Novedades': null
                    }
                }

                if (original != null) {
                    novedadFinal.TarjetaCredito.Id = novedad.Id;
                }
                else {
                    novedadFinal.TarjetaCredito.Id = tieneNovedadOriginal != null ? novedad.TarjetaCreditoId : null;
                    novedadNueva.Id = novedad.Id;
                }
                novedadNueva.NovedadCampoId = novedadCampoTarjeta.Id;
                novedadNueva.NovedadCampoCodigo = novedadCampoTarjeta.Codigo;
                novedadNueva.ValorAnterior = original != null ? original.PorcentajeLimiteCompra : tieneNovedadOriginal.PorcentajeLimiteCompra;
                novedadNueva.ValorNovedad = original != null ? novedad.PorcentajeLimiteCompra : novedad.ValorNovedad;

                novedades.push(novedadNueva);
                novedadFinal.TarjetaCredito.Novedades = novedades;
                break;
        }

        return novedadFinal;
    }

    /**
     * Ejecuta la saga de Distribución de Límites
     * @param {any} localValues
     * @param {any} saga
     * @param {any} sagasCallback
     * @param {any} viewCallback
     */
    function ejecutarSagas(localValues, saga, sagasCallback, viewCallback) {
        SagasProxy.AddSagaRequests(localValues, saga, "TARJETAS", "CONSULTASOCIOS");

        RestApiProxy.SetApiUrl();

        SagasProxy.Execute(sagasCallback, undefined, viewCallback, "CONSULTASOCIOS");
    }

    return {
        GuardarLimites: function (data, sagasCallback, viewCallback, executionContext, novedadesCampoLimites) {
            return _guardarLimites(data, sagasCallback, viewCallback, executionContext, novedadesCampoLimites);
        },
        GenerarNovedades: function (data, executionContext, novedadesCampoLimites) {
            return _generarNovedades(data, executionContext, novedadesCampoLimites);
        }
    }
};

let distribucionLimitesManager = new DistribucionLimitesManager();
export default distribucionLimitesManager;